import { useNavigate } from 'react-router-dom';

const trackClick = (source: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'for_sale_click', { source });
  }
};

const ForSaleFloatingBadge = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    trackClick('floating_badge');
    navigate('/for-sale');
  };

  const handleSideTabClick = () => {
    trackClick('side_tab');
    navigate('/for-sale');
  };

  return (
    <>
      {/* Sticky Floating Badge */}
      <button
        onClick={handleClick}
        aria-label="This website is for sale - view details"
        className="
          fixed z-[9999] cursor-pointer
          top-4 right-4
          md:top-6 md:right-6
          bottom-auto
          max-sm:top-auto max-sm:bottom-4 max-sm:right-4
          bg-red-600 text-white
          px-4 py-3 rounded-xl
          shadow-xl shadow-red-900/30
          rotate-1
          hover:rotate-0 hover:scale-105
          transition-all duration-200
          border-2 border-red-400
          flex flex-col items-center leading-tight
          animate-[badgePulse_3s_ease-in-out_infinite]
          whitespace-nowrap
        "
        style={{ transform: 'rotate(2deg)' }}
        onMouseEnter={e => (e.currentTarget.style.transform = 'rotate(0deg) scale(1.05)')}
        onMouseLeave={e => (e.currentTarget.style.transform = 'rotate(2deg)')}
      >
        <span className="text-sm font-black tracking-widest uppercase">FOR SALE</span>
        <span className="text-[10px] font-medium text-red-100 tracking-wide">Own This Website</span>
      </button>

      {/* Vertical Side Tab — Desktop Only */}
      <button
        onClick={handleSideTabClick}
        aria-label="Website for sale"
        className="
          hidden lg:flex
          fixed right-0 top-1/2 -translate-y-1/2 z-[9998]
          bg-red-600 text-white
          flex-col items-center justify-center
          py-6 px-2.5
          rounded-l-xl
          shadow-lg shadow-red-900/20
          cursor-pointer
          hover:bg-red-700 hover:px-3.5
          transition-all duration-200
          border-l-0 border-t-2 border-b-2 border-r-0 border-red-400
          whitespace-nowrap
          gap-1
        "
      >
        <i className="ri-price-tag-3-fill text-sm mb-2"></i>
        {['F','O','R',' ','S','A','L','E'].map((char, i) => (
          <span key={i} className="text-[11px] font-black tracking-wider leading-none">{char === ' ' ? <span className="block h-2" /> : char}</span>
        ))}
      </button>

      <style>{`
        @keyframes badgePulse {
          0%, 100% { box-shadow: 0 10px 25px -3px rgba(220,38,38,0.3), 0 4px 6px -4px rgba(220,38,38,0.2); }
          50% { box-shadow: 0 10px 35px -3px rgba(220,38,38,0.6), 0 4px 6px -4px rgba(220,38,38,0.4); }
        }
      `}</style>
    </>
  );
};

export default ForSaleFloatingBadge;
